/**
 * Lodestar — SPA route-change pageview tracker.
 *
 * Mounted inside <BrowserRouter> so it can use `useLocation`. Every
 * pathname change fires:
 *   • GA4 `page_view` event (gtag respects Consent Mode v2 gate)
 *   • PostHog `$pageview` capture (auto-handled by their snippet too,
 *     but we mirror here for completeness if PH ever drops the auto)
 *
 * Why a separate component, not a hook inside App?
 *   • Keeps Suspense + lazy boundaries quiet — this never re-renders
 *     anything, returns null.
 *   • Hook-only file means lint stays clean on the noop component.
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageview, track } from "@/lib/analytics";

export default function RouteAnalytics() {
    const { pathname, search } = useLocation();
    useEffect(() => {
        const fullPath = pathname + (search || "");
        // GA4 pageview (gated by Consent Mode v2)
        trackPageview(fullPath);
        // PostHog mirror — also a no-op if PostHog not loaded.
        track("$pageview", { $current_url: window.location.href, path: fullPath });
    }, [pathname, search]);
    return null;
}
